import EditIcon from 'assets/icons/edit';
import { Button, Tooltip } from '@mui/material';

const EditButton = ({ handleOnClick }) => {
	return (
		<Tooltip title="Edit">
			<span>
				<Button
					size="small"
					variant="outlined"
					onClick={handleOnClick}
					startIcon={<EditIcon width="18px" height="18px" color="#00b050" />}
					sx={{
						fontWeight: 500,
						fontSize: '13px',
						lineHeight: '22px',
						padding: '4px 12px',
						borderRadius: '4px',
						textTransform: 'none',
						borderColor: '#d9d9d9',
						backgroundColor: '#fff',
						transition: 'all 0.25s ease',
						color: 'rgba(0, 0, 0, 0.88)',

						'&:hover': {
							color: '#4096ff',
							transform: 'scale(1.05)',
							borderColor: '#4096ff',
							backgroundColor: '#fff',
						},

						'&:active': {
							backgroundColor: '#e6f4ff',
						},

						'&.Mui-disabled': {
							borderColor: '#d9d9d9',
							backgroundColor: '#f5f5f5',
							color: 'rgba(0, 0, 0, 0.25)',
						},
					}}
				>
					Edit
				</Button>
			</span>
		</Tooltip>
	);
};

export default EditButton;

// import { Tooltip } from 'antd';
// import { Button } from '@mui/material';
// import editIcon from 'assets/images/table-icons/edit_green.svg';

// const EditButton = ({ handleOnClick }) => {
// 	return (
// 		<Tooltip title="Edit">
// 			<Button
// 				onClick={handleOnClick}
// 				sx={{
// 					py: '4px',
// 					gap: '4px',
// 					margin: '1px',
// 					color: '#000',
// 					display: 'flex',
// 					fontSize: '13px',
// 					fontWeight: '500',
// 					borderRadius: '6px',
// 					transition: 'all 0.1s',
// 					border: '1px solid #d9d9d9',

// 					'&:hover': {
// 						transform: 'scale(1.05)',
// 					},
// 				}}
// 			>
// 				<img src={editIcon} width={16} height={16} alt="edit" />
// 				Edit
// 			</Button>
// 		</Tooltip>
// 	);
// };

// export default EditButton;
